import React from 'react';

const CustomTooltip = ({ payload }) => {
  if (!payload.filter(entry => entry.value).length) {
    return null;
  }
  return (
    <ul className="chart__tooltip">
      {payload.map((entry, index) =>
        entry.value ? (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`item-${index}`}>
            <span style={{ backgroundColor: entry.color }} className="chart__tooltip__disk" />
            <var>{entry.value}</var> Sold
          </li>
        ) : null
      )}
    </ul>
  );
};

export default CustomTooltip;
